<script setup>
  import { ref, onMounted, watch, watchEffect} from 'vue';
  import { useUserStore } from '@/stores/UserStore'
  import BaseModal from './base/BaseModal.vue';
  import ModalContentTextInput from '@/components/ModalContentTextInput.vue';
  
  const emits = defineEmits(['close']);

  const props = defineProps({
    show: {
      type: Boolean,
      default: false
    },
  });

  const userStore = useUserStore();

  const profileName = ref(``);
  const showModal = ref(false);

  function closeModal() {
    showModal.value = false;

    emits('close');
  }

  async function createProfile() {
    if (!profileName.value) {
      if (jwc) {
        jwc.toaster.toast({
          type: 'warning',
          content: `Profile Name is required.`,
        })
      } 

      return;
    }

    await userStore.addProfile(profileName.value);
    await userStore.getProfiles(true);

    if (jwc) {
      jwc.toaster.toast({
        type: 'success',
        content: `Created profile ${profileName.value}`,
      })
    }     

    closeModal();
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  })

  watch(() => props.profileId, () => {
    profileName.value = userStore.getProfileById(props.profileId).name;
  }, { immediate: true });

</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="true"
  >
    <ModalContentTextInput
      v-model="profileName"
      modalTitle="Create New Profile"
      labelText="Name"
      acceptButtonText="Save"
      :required="true"
      @accept="createProfile"
      @cancel="closeModal"
    /> 
  </BaseModal>
</template>